module.exports = __webpack_public_path__ + "img/stock7.cb10cfe7.png";